/**
 * Docs from
 * https://primeng.org/togglebutton
 */
export const togglebutton = {
  root: {
    padding: 0,
  },
  content: {
    padding: '.5rem 1rem',
  },
  colorScheme: {
    light: {
      root: {
        color: '{stone.950}',
        checkedColor: '{stone.50}',
        hoverBackground: '{surface.200}',
      },
      content: {
        checkedBackground: '{blue.500}',
      },
    },
  },
  extend: {
    hover: {
      selected: {
        background: '{blue.700}',
      },
      default: {
        background: '{stale.300}',
      },
    },
  },
  css: ({ dt }: { dt: any }) => `
    .p-togglebutton {
      border: none;
    }
    .p-togglebutton-checked:hover .p-togglebutton-content {
      background:  ${dt('togglebutton.hover.selected.background')};
    }
  `,
};
